import storage from "./storage";

export function setStorageData(key, value){
  // storage[key] = value;
  sessionStorage.setItem(key, JSON.stringify(value));
}

export function getStorageData(key){
  // return storage[key];
  const value = sessionStorage.getItem(key);
  return value ? JSON.parse(value) : null;
}